import { CarInformation } from '../Types/FitAssistantData.ts';

export const setQueryFromSearchParameters = (cookieName: string, carInfo: CarInformation[]): void => {
  const url = new URL(document.location.href);
  const setSearchParameters: string = carInfo
    .map((item) => `${item.parameterName}:${item.value}|${encodeURI(item.text)}`)
    .join(',');
  url.searchParams.set(cookieName, setSearchParameters);
  history.replaceState(null, '', url.toString());
};

export const getSearchParametersFromQuery = (name: string): string | null => {
  const regexString: string = '[\\?&]' + name + '=([^&#]*)';
  const regex: RegExp = new RegExp(regexString);
  const results = regex.exec(window.location.search);
  if (results === null) {
    return null;
  } else {
    return decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
};

export const hasOpenFitAssistantQueryParameter = () => {
  return getSearchParametersFromQuery('openfa') === 'true';
};
